const OLD_MARGIN = 10;
const MARGIN = 30;

export const screenContext = (
  rectStart: number,
  rectHeight: number,
  shouldUsePopoverDynamicPositioning: boolean,
  aWindow = window,
  aDocument = document,
) => {
  const scrollYOffset =
    aWindow.scrollY || aWindow.pageYOffset || (aDocument.documentElement && aDocument.documentElement.scrollTop) || 0;

  const bodyHeight = aDocument.body.offsetHeight;
  const remainingHeight = bodyHeight - scrollYOffset - rectStart;
  const fit = remainingHeight > rectHeight;
  const overTop = rectHeight - bodyHeight;

  const oldRectOffset = overTop - OLD_MARGIN;
  const rectOffset = -rectHeight + remainingHeight - MARGIN; // -rectHeight: move rect above toggle button; remainingHeight: adjust rect to fit just above body bottom.

  if (shouldUsePopoverDynamicPositioning) {
    const top = fit ? 0 : rectOffset;

    return {
      fit,
      top,
    };
  }

  const top = fit ? 0 : oldRectOffset;

  return {
    fit,
    top,
  };
};
